module.exports = __webpack_public_path__ + "img/landing-invest-banner-mark.7cf58567.svg";